import { VERISOUL_IDENTITY_ANDROID_VERSION_CODE } from '../constants'

export const IDENTITY_PROVIDER = {
  STRIPE: 'stripe',
  VERISOUL: 'verisoul',
}

const getForcedProvider = (envName) => {
  const forcedProvider = process.env[envName]?.trim().toLowerCase()
  return Object.values(IDENTITY_PROVIDER).includes(forcedProvider) ? forcedProvider : null
}

export const resolveIdentityProvider = ({ isNativeApp, versionCode }) => {
  const forcedProvider = getForcedProvider(
    isNativeApp
      ? 'REACT_APP_FORCE_NATIVE_IDENTITY_PROVIDER'
      : 'REACT_APP_FORCE_WEB_IDENTITY_PROVIDER'
  )

  if (!isNativeApp) {
    return forcedProvider || IDENTITY_PROVIDER.VERISOUL
  }

  const parsedVersionCode = Number(versionCode)
  const supportsVerisoul =
    Number.isFinite(parsedVersionCode) &&
    parsedVersionCode >= VERISOUL_IDENTITY_ANDROID_VERSION_CODE

  if (forcedProvider === IDENTITY_PROVIDER.STRIPE || !supportsVerisoul) {
    return IDENTITY_PROVIDER.STRIPE
  }

  return IDENTITY_PROVIDER.VERISOUL
}
